export const malldata = [
  {
    id: 1,
    imageurl:
      "https://static-01.daraz.com.np/p/5f653d69ef1700b54fdbcbf262bb9da0.jpg",
    logourl:
      "https://static-01.daraz.com.np/other/shop/a00d12a8e499c0acc59550d84a4852a8.png",
    title: "Buddsbuddy",
    desc: "Buddsbuddy",
  },
  {
    id: 2,
    imageurl:
      "https://static-01.daraz.com.np/p/245a7ad2a88f989eb28d5d02148fe62a.jpg",
    logourl:
      "https://static-01.daraz.com.np/other/shop/88a91996b557a62013322f11c5ae9690.png",
    title: "Little Trees",
    desc: "The Original",
  },
  {
    id: 3,
    imageurl:
      "https://static-01.daraz.com.np/p/918757a06a35f861154bbdff9435f402.jpg",
    logourl:
      "https://static-01.daraz.com.np/other/shop/a2cbcebe92cedf6631e33678286ed46c.png",
    title: "Mamaearth",
    desc: "From Nature, With Love",
  },
  {
    id: 4,
    imageurl:
      "https://static-01.daraz.com.np/p/41af737cdccfab3bd18c8c97028994eb.jpg",
    logourl:
      "https://static-01.daraz.com.np/other/shop/a418d259af5ddb31265ca8cb044fc82f.png",
    title: "CHEESTICK",
    desc: "CHEESTICK",
  },
  {
    id: 5,
    imageurl:
      "https://static-01.daraz.com.np/p/82b7b776966eaecc7ce8ede049bebbfe.jpg",
    logourl:
      "https://static-01.daraz.com.np/other/shop/31abd9dbeff461e8ddf151f4276f6ad4.jpeg",
    title: "Chickool",
    desc: "Chickool",
  },
  {
    id: 6,
    imageurl:
      "https://static-01.daraz.com.np/p/79994a5b8f7f3dab71fac2e69902b7ed.jpg",
    logourl:
      "https://static-01.daraz.com.np/other/shop/0242be2c1fbdeeac5217b2aa13e546be.png",
    title: "Chicco",
    desc: "chicco",
  },
];